import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import { MetricasService } from './metricas.service';

/**
 * TR-22 (B2): mide cada llamada HttpClient (PHP, HubSpot, etc.): duración y
 * status. No modifica la petición ni la respuesta, y no se mide a sí mismo
 * (el POST de lotes a metricas/lote.php va por XHR/sendBeacon, no por HttpClient).
 */
@Injectable()
export class MetricasInterceptor implements HttpInterceptor {
    constructor(private metricas: MetricasService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.metricas.estaHabilitado() || this.metricas.esUrlDeMetricas(req.url)) {
            return next.handle(req);
        }
        const medicion = this.metricas.iniciarMedicion(this.metricas.normalizarUrl(req.url));
        let status = 0;
        let terminada = false;
        return next.handle(req)
            .do(
                (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        status = event.status;
                        terminada = true;
                        medicion.fin(event.status < 400, event.status);
                    }
                },
                (err: any) => {
                    terminada = true;
                    status = err instanceof HttpErrorResponse ? err.status : 0;
                    medicion.fin(false, status);
                }
            )
            // Petición cancelada (unsubscribe) sin respuesta: no se registra.
            .finally(() => { if (!terminada) { medicion.cancelar(); } });
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/monitoring/metricas.interceptor.ts